import {
  initializeWidgetConfiguration,
  SgWidget,
  WidgetConfigurationProvider,
  WithGlobalCss,
} from "@sgwt-widget/core";
import { h } from "preact";
import { emit, props } from "skatejs";
import WidgetTracker from "../common/components/WidgetTracker/WidgetTracker";
import { getUserEmail } from "../common/utils/storage";
import { ITakeClientAndDateProps } from "../common/utils/types";
import { NbiTopPerTeamAndProduct } from "./components/NbiTopPerTeamAndProduct";

class CprNbiTopPerTeamAndProduct extends SgWidget<ITakeClientAndDateProps> {
  public static is = "cpr-nbi-top-per-team-and-product";
  public static props = {
    client: { ...props.object, default: undefined },
    userSelection: props.object,
  };

  public render(intraprops: ITakeClientAndDateProps) {
    const headers = { uiscreen: (this.constructor as any).is };

    const userEmail = this.props.userEmail || getUserEmail(localStorage);
    const onChange = (value: string) => {
      const newValue = { columns: value };
      intraprops.userSelection = newValue;
      emit(this, "cpr-nbi-top-per-team-and-product--order-changed", {
        detail: newValue,
      });
    };
    return (
      <WidgetConfigurationProvider
        widgetConfiguration={this.widgetConfiguration}
      >
        <WithGlobalCss>
          <NbiTopPerTeamAndProduct
            onChange={onChange}
            client={intraprops.client}
            userEmail={userEmail}
            headers={headers}
            userSelection={intraprops.userSelection}
          />
          <WidgetTracker widgetName={CprNbiTopPerTeamAndProduct.is} />
        </WithGlobalCss>
      </WidgetConfigurationProvider>
    );
  }
}

initializeWidgetConfiguration(CprNbiTopPerTeamAndProduct);
customElements.define(
  CprNbiTopPerTeamAndProduct.is,
  CprNbiTopPerTeamAndProduct
);
